// Toggle the menu open and close when on mobile
export default function menuOpen() {
    const hamburgerMenu = document.getElementById("hamburger-menu");
    const mobileMenu = document.getElementById("mobile-menu");

    hamburgerMenu.addEventListener("click", () => {
        hamburgerMenu.classList.toggle("active");
        mobileMenu.classList.toggle("active");
    });
}
